// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let FeaturesV3 = require("../../../../reason/featureFlipper/FeaturesV3.bs.js");
let Form__Input = require("../../../../uikit/reason/atoms/Form/Form__Input.bs.js");
let LotSizeUtils = require("../../../common/Property/LotSizeUtils.bs.js");
let Form__Helpers = require("../../../../reason/common/Form/Form__Helpers.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let LotSizeUnitSelect = require("./LotSizeUnitSelect.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function formatInputValue(value) {
  return Stdlib_Option.mapOr(value, "", LotSizeUtils.formatValue);
}

function parseInputValue(inputValue, lotSizeUnit) {
  if (lotSizeUnit === "ACRE") {
    return Form__Helpers.floatFromFormattedNumberString(inputValue);
  } else {
    return Stdlib_Option.map(Form__Helpers.intFromFormattedNumberString(inputValue), prim => prim);
  }
}

function LotSizeInput(props) {
  let status = props.status;
  let onUnitBlur = props.onUnitBlur;
  let onUnitChange = props.onUnitChange;
  let onBlur = props.onBlur;
  let onChange = props.onChange;
  let lotSizeUnit = props.lotSizeUnit;
  let value = props.value;
  let lotSizeUnitEnabled = FeaturesV3.useLotSizeUnitEnabled();
  let effectiveLotSizeUnit = lotSizeUnitEnabled ? lotSizeUnit : "SQ_FT";
  let formattedValue = Stdlib_Option.mapOr(value, "", LotSizeUtils.formatValue);
  let match = React.useState(() => formattedValue);
  let setInputValue = match[1];
  let match$1 = React.useState(() => false);
  let setIsEditing = match$1[1];
  let isEditing = match$1[0];
  React.useEffect(() => {
    if (!isEditing) {
      setInputValue(param => formattedValue);
    }
  }, [
    formattedValue,
    isEditing
  ]);
  let handleUnitChange = nextUnit => {
    if (effectiveLotSizeUnit === "ACRE" && nextUnit === "SQ_FT") {
      onChange(LotSizeUtils.truncateToSqFt(value));
    }
    onUnitChange(nextUnit);
  };
  return JsxRuntime.jsx(Form__Input.make, {
    labelText: "Lot Size",
    optionalText: props.optionalText,
    onChange: evt => {
      let nextInputValue = evt.target.value;
      let nextValue = parseInputValue(nextInputValue, effectiveLotSizeUnit);
      setIsEditing(param => true);
      setInputValue(param => LotSizeUtils.formatInputString(nextInputValue, effectiveLotSizeUnit));
      onChange(nextValue);
    },
    onBlur: param => {
      setIsEditing(param => false);
      onBlur();
    },
    onFocus: param => setIsEditing(param => true),
    status: status,
    append: lotSizeUnitEnabled ? undefined : "sqft",
    appendElement: lotSizeUnitEnabled ? JsxRuntime.jsx(LotSizeUnitSelect.make, {
        value: lotSizeUnit,
        onChange: handleUnitChange,
        onBlur: param => onUnitBlur(),
        status: status,
        embedded: true
      }) : undefined,
    value: match[0]
  });
}

let make = LotSizeInput;

exports.formatInputValue = formatInputValue;
exports.parseInputValue = parseInputValue;
exports.make = make;
/* react Not a pure module */
